import React from 'react';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import './LoanDataDisplay.scss';
import fmt from 'indian-number-format';

export interface PnlReportItem {
  sNo: string;
  particulars: string;
  amount: number;
  kind: 'stock' | 'section' | 'subtotal' | 'item' | 'total';
  grams?: number;
}

interface PnlReportProps {
  data: PnlReportItem[];
}

const columns: ColumnsType<PnlReportItem> = [
  {
    title: 'S.No',
    dataIndex: 'sNo',
    key: 'sNo',
    width: 80,
  },
  {
    title: 'Particulars',
    dataIndex: 'particulars',
    key: 'particulars',
    render: (val: string, row) =>
      row.kind === 'stock' ? `${val} (${row.grams ?? 0} g)` : val,
  },
  {
    title: 'Amount (₹)',
    dataIndex: 'amount',
    key: 'amount',
    width: 220,
    render: (val: number, row) =>
      row.kind === 'section' ? '' : fmt.format(val.toFixed(2)),
  },
];

const PnlReportDisplay: React.FC<PnlReportProps> = ({ data }) => (
  <div className="loan-data-container">
    <h2>P&L Report</h2>
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(row) => `${row.sNo}-${row.particulars}`}
      pagination={false}
      rowClassName={(row) =>
        row.kind === 'item' ? '' : row.kind === 'subtotal' ? 'pnl-subtotal-row' : 'totals-row'
      }
    />
  </div>
);

export default PnlReportDisplay;
